import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Tabs from './Tabs'
import Details from '../../../../../Modules/Details/Details'
import ManageEntities from '../../../../../Modules/ManageEntities/ManageEntities'
import { paths } from '../../../../../../app/routes'

const PAGE_TAB_PATHS = {
    Mappings: paths.productMappings,
    AttributeMappings: paths.productAttributeMappings
}

/**
 * One connector's tabs. `connector` is describeConnection() of the connection
 * (features/connections/connectionsApi). Mappings (PATH.PRODUCT_MAPPINGS) and
 * Attribute Mappings (PATH.PRODUCT_ATTRIBUTE_MAPPINGS) open their own pages
 * instead of rendering inside this card.
 */
const SelectedConnector = ({ connector, businessEntitiesSource, businessEntitiesTarget }) => {
    const [tabType, setTabType] = useState('Details')
    const history = useHistory()
    const location = useLocation()

    // Picking a different connector always lands on Details.
    useEffect(() => {
        setTabType('Details')
    }, [connector.connectorId])

    const selectTab = (key) => {
        const pagePath = PAGE_TAB_PATHS[key]
        if (pagePath) {
            // Remember where we came from so the mappings page can send the user back here.
            history.push(pagePath(connector.connectorId), {
                from: `${location.pathname}${location.search}`
            })
            return
        }
        setTabType(key)
    }

    return (
        <>
            <div className="card-header bg-transparent">
                <h4 className="card-title mb-2 card-title-wth-border titlecustomNew">{connector.displayName}</h4>
                <Tabs getActiveTab={selectTab} activeTab={tabType} />
            </div>
            <div className="card-body pleft-0 pright-0">
                <div className="row">
                    {tabType === 'ManageEntities' ? (
                        <ManageEntities
                            connectorId={connector.connectorId}
                            instancesId={connector.instanceId}
                            subscriptionId={connector.subscriptionId}
                            sourceShortName={connector.source.shortName}
                            targetShortName={connector.target.shortName}
                        />
                    ) : (
                        <Details
                            connector={connector}
                            businessEntitiesSource={businessEntitiesSource}
                            businessEntitiesTarget={businessEntitiesTarget}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default SelectedConnector
